import ChevronDown16 from '@carbon/icons-react/es/chevron--down/16';
import { Menu, Dropdown } from 'antd';
import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './range-picker.module.css';

export enum Ranges {
  One = 'One week',
  Two = 'Two weeks',
  Three = 'Three weeks',
  Four = 'Four weeks',
}

export const rangeValueMap = {
  [Ranges.One]: 1,
  [Ranges.Two]: 2,
  [Ranges.Three]: 3,
  [Ranges.Four]: 4,
};

interface Props {
  onDateChange: (weeks: string) => void;
  rangeType: Ranges;
}

const rangeTranslationMap = {
  [Ranges.One]: 'picker.one_week',
  [Ranges.Two]: 'picker.two_weeks',
  [Ranges.Three]: 'picker.three_weeks',
  [Ranges.Four]: 'picker.four_weeks',
};

export const StringRangePicker: FC<Props> = ({ onDateChange, rangeType }) => {
  const handleMenuItemClick = useCallback(
    (e) => {
      onDateChange(e.key);
    },
    [onDateChange],
  );

  const menu = (
    <Menu onClick={handleMenuItemClick}>
      <Menu.Item key={Ranges.One}>
        <FormattedMessage id={rangeTranslationMap[Ranges.One]} />
      </Menu.Item>
      <Menu.Item key={Ranges.Two}>
        <FormattedMessage id={rangeTranslationMap[Ranges.Two]} />
      </Menu.Item>
      <Menu.Item key={Ranges.Three}>
        <FormattedMessage id={rangeTranslationMap[Ranges.Three]} />
      </Menu.Item>
      <Menu.Item key={Ranges.Four}>
        <FormattedMessage id={rangeTranslationMap[Ranges.Four]} />
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu}>
      <span className={styles.title}>
        <FormattedMessage id={rangeTranslationMap[rangeType]} />
        <ChevronDown16 />
      </span>
    </Dropdown>
  );
};
